import BaseListPresenter from "../../../base/BaseListPresenter";
import { findObjectUseCase } from "../../../usecases/object";

class ExecutiveDashboardPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    this.limit = 10;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  // findCollection = () => {
  //   return Promise.all([
  //     findObjectUseCase().execute("Users", {
  //       where: {
  //         "roles.0": { $exists: true },
  //         status: "active",
  //       },
  //       includes: ["employee"],
  //     }),
  //     findObjectUseCase().execute("employees", {
  //       keys: [
  //         "region",
  //         "office",
  //         "division",
  //         "section",
  //         "unit",
  //         "cluster",
  //         "age",
  //         "sex",
  //         "Firstname",
  //         "Middlename",
  //         "surname",
  //       ],
  //     }),
  //     findObjectUseCase().execute("Division", {
  //       where: { status: "active" },
  //       keys: ["name"],
  //     }),
  //     findObjectUseCase().execute("Clusters", {
  //       where: { status: "active" },
  //       keys: ["name"],
  //     }),

  //     findObjectUseCase().execute("Region", {
  //       where: { status: "active" },
  //       keys: ["name"],
  //     }),
  //     findObjectUseCase().execute("offices", {
  //       where: { status: "active" },
  //       keys: ["name"],
  //     }),
  //     findObjectUseCase().execute("Sections", {
  //       where: { status: "active" },
  //       keys: ["name"],
  //     }),
  //     findObjectUseCase().execute("Units", {
  //       where: { status: "active" },
  //       keys: ["name"],
  //     }),
  //   ]);
  // };

  fetchAllInChunks = async (
    findObjectUseCase,
    collection,
    baseQuery = {},
    limit = 500
  ) => {
    let skip = 0;
    let hasMore = true;

    const stateField = {
      users: "Users",
      employees: "Employees",
      Region: "OCOM",
      offices: "Location",
      Division: "Region",
      Sections: "Subport",
      Units: "Division",
      Clusters: "Section",
    };

    while (hasMore) {
      const chunk = await findObjectUseCase().execute(collection, {
        ...baseQuery,
        limit,
        skip,
      });

      if (!chunk || chunk.length === 0) {
        hasMore = false;
      } else {
        const field = stateField[collection];

        // ✅ FIX: Append new chunk to existing data
        this.view.setState((prevState) => ({
          [field]: [...(prevState[field] || []), ...chunk],
        }));

        skip += limit;
      }
    }
  };

  findCollection = async () => {
    const limit = 500;

    // ✅ FIX: Initialize all collections as empty arrays first
    this.view.setState({
      Users: [],
      Employees: [],
      OCOM: [],
      Location: [],
      Region: [],
      Subport: [],
      Division: [],
      Section: [],
      isLoading: true,
    });

    await Promise.all([
      this.fetchAllInChunks(
        findObjectUseCase,
        "users",
        {
          where: {
            "roles.0": { $exists: true },
            status: "active",
          },
          keys: [
            "employee.Firstname",
            "employee.Middlename",
            "employee.surname",
            "username",
          ],
          includes: ["employee"],
        },
        limit
      ),

      this.fetchAllInChunks(
        findObjectUseCase,
        "employees",
        {
          keys: [
            "region",
            "office",
            "division",
            "section",
            "unit",
            "cluster",
            "age",
            "sex",
            "Firstname",
            "Middlename",
            "surname",
          ],
        },
        limit
      ),

      this.fetchAllInChunks(
        findObjectUseCase,
        "Region",
        {
          where: { status: "active" },
          keys: ["name"],
        },
        limit
      ),

      this.fetchAllInChunks(
        findObjectUseCase,
        "offices",
        {
          where: { status: "active" },
          keys: ["name"],
        },
        limit
      ),

      this.fetchAllInChunks(
        findObjectUseCase,
        "Division",
        {
          where: { status: "active" },
          keys: ["name"],
        },
        limit
      ),

      this.fetchAllInChunks(
        findObjectUseCase,
        "Sections",
        {
          where: { status: "active" },
          keys: ["name"],
        },
        limit
      ),

      this.fetchAllInChunks(
        findObjectUseCase,
        "Units",
        {
          where: { status: "active" },
          keys: ["name"],
        },
        limit
      ),

      this.fetchAllInChunks(
        findObjectUseCase,
        "Clusters",
        {
          where: { status: "active" },
          keys: ["name"],
        },
        limit
      ),
    ]);
  };

  async componentDidMount() {
    await this.findCollection();
  }

  onSelectChange = async (value) => {
    this.view.setState({
      selected: value,
    });
  };

  UserGenerateExcel = (objects) => {
    let csvContent = "First name, Middle name, Last name, Username\n"; // CSV header

    const escapeCsvValue = (value) => {
      if (typeof value === "string" && value.includes(",")) {
        return `"${value}"`;
      }
      return value;
    };

    objects.forEach((item) => {
      const firstName = escapeCsvValue(item.employee.Firstname || "");
      const middlename = escapeCsvValue(item.employee.Middlename || "");
      const surname = escapeCsvValue(item.employee.surname || "");
      const username = escapeCsvValue(item.username || "");
      csvContent += `${firstName},${middlename},${surname},${username}\n`;
    });

    this.generatePrint(csvContent);
  };

  EmployeeGenerateExcel = (objects) => {
    let csvContent = "First name, Middle name, Last name\n"; // CSV header

    const escapeCsvValue = (value) => {
      if (typeof value === "string" && value.includes(",")) {
        return `"${value}"`;
      }
      return value;
    };

    objects.forEach((item) => {
      const firstName = escapeCsvValue(item.Firstname || "");
      const middlename = escapeCsvValue(item.Middlename || "");
      const surname = escapeCsvValue(item.surname || "");
      csvContent += `${firstName},${middlename},${surname}\n`;
    });

    this.generatePrint(csvContent);
  };

  ageGroupGenerateExcel = (objects) => {
    let csvContent = "First name,Middle name,Last name,Age\n"; // CSV header

    const escapeCsvValue = (value) => {
      if (typeof value === "string" && value.includes(",")) {
        return `"${value}"`;
      }
      return value;
    };

    objects.forEach((item) => {
      const firstName = escapeCsvValue(item.Firstname || "");
      const middlename = escapeCsvValue(item.Middlename || "");
      const surname = escapeCsvValue(item.surname || "");
      const age = escapeCsvValue(item.age || "");
      csvContent += `${firstName},${middlename},${surname},${age}\n`;
    });

    this.generatePrint(csvContent);
  };

  genderGenerateExcel = (objects) => {
    let csvContent = "First name,Middle name,Last name,Gender\n"; // CSV header

    const escapeCsvValue = (value) => {
      if (typeof value === "string" && value.includes(",")) {
        return `"${value}"`;
      }
      return value;
    };

    objects.forEach((item) => {
      const firstName = escapeCsvValue(item.Firstname || "");
      const middlename = escapeCsvValue(item.Middlename || "");
      const surname = escapeCsvValue(item.surname || "");
      const gender = escapeCsvValue(item.sex || "");
      csvContent += `${firstName},${middlename},${surname},${gender}\n`;
    });

    this.generatePrint(csvContent);
  };

  plantillaGenerateExcel = (
    Region,
    Group,
    Offices,
    Division,
    Section,
    Plantilla
  ) => {
    const arrays = {
      Region,
      Group,
      Offices,
      Division,
      Section,
      Plantilla,
    };

    // Find the maximum length among all arrays for alignment
    const maxLength = Math.max(
      ...Object.values(arrays).map((arr) => arr.length)
    );

    let csvContent = ""; // Initialize CSV content

    // Add headers to the CSV
    csvContent += Object.keys(arrays).join(",") + "\n";

    // Add rows, aligning data by filling missing cells with empty strings
    for (let i = 0; i < maxLength; i++) {
      const row = Object.keys(arrays)
        .map((key) => {
          const item = arrays[key][i];
          return item ? this.escapeCsvValue(item.name) : ""; // Escape value or add empty
        })
        .join(",");
      csvContent += row + "\n";
    }

    this.generatePrint(csvContent);
  };

  escapeCsvValue(value) {
    if (typeof value === "string" && value.includes(",")) {
      return `"${value}"`;
    }
    return value || ""; // Ensure null or undefined values are empty
  }

  generatePrint(csvContent) {
    // Ensure the CSV is saved with UTF-8 encoding
    const blob = new Blob([`\uFEFF ${csvContent}`], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `report.csv`);
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
export default ExecutiveDashboardPresenter;
